import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import LeaseApiService from '../../services/apiService';
import { IoSearch } from "react-icons/io5";
import moment from 'moment';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SingleInvoice = () => {
    const apiService = new LeaseApiService();
    const [loading, setloader] = useState(false);
    const [propertylist, setPropertyList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [leasingAgent, setLeasingAgent] = useState([]);
    const [leaseList, setleaseList] = useState([]);
    const [typeList, setType] = useState([]);
    const [periodFrom, setPeriodFrom] = useState("");
    const [periodTo, setPeriodTo] = useState("");
    const [transectionDate, settransectionDate] = useState("");
    const [leaseTerm, setLeaseTerm] = useState([]);
    const [groupId, setGroupId] = useState(false);
    const totalRent = leaseTerm?.reduce((sum, row) => sum + (parseFloat(row?.Rent) || 0), 0);
    const totalVat = leaseTerm?.reduce((sum, row) => sum + (parseFloat(row?.VAT) || 0), 0);
    const totalAmount = leaseTerm?.reduce((sum, row) => sum + (parseFloat(row?.Total) || 0), 0);
    const navigate = useNavigate();
    // const { encode, decode } = require('url-encode-decode')
    // let url = decode('%2BZhDmciUREwE8CkJMo3bwQ%3D%3D&_db=wCKZqDR')

    const [formData, setFormData] = useState({
        itemNo: { label: 'Select ItemNo', value: 'All' },
        ItemDescription: { label: 'Select Item', value: 'All' },
        email: "",
        property: [{ label: 'Select Property', value: 'Select Property' }],
        unit: [{ label: 'Select Unit', value: 'Select Unit' }],
        type: [{ label: 'Select Type', value: 'Select Type' }],
        tanent: [{ label: 'Select Tenant', value: 'Select Tenant' }],
        leaseNo: [{ label: 'Select Lease No', value: 'Select Lease No' }],
    });
    useEffect(() => {
        getUserList()
    }, []);
    useEffect(() => {
        const today = new Date();
        const nextMonth = new Date(today);
        nextMonth.setMonth(today.getMonth() + 1);
        nextMonth.setDate(nextMonth.getDate() + 1);
        const formattedToday = today.toISOString().split("T")[0];
        const formattedNextYear = nextMonth.toISOString().split("T")[0];

        setPeriodFrom(formattedToday);
        setPeriodTo(formattedNextYear);
        settransectionDate(formattedToday)
    }, []);

    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    };

    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    };

    const handleTransDate = ({ name, value }) => {
        const formattedDate = formatDate(value);
        settransectionDate(formattedDate);
    };

    const getUserList = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LSISerPropertyName,LSICustomerName,LSISerUnitTypeDesc,LSISerLeaseNo');
            const customerRes = await apiService.getApiParamater('GET_INVOICE_DROP', `?${params.toString()}`);
            setPropertyList(customerRes?.data?.dropdowns?.LSISerPropertyName);
            setLeasingAgent(customerRes?.data?.dropdowns?.LSICustomerName);
            setleaseList(customerRes?.data?.dropdowns?.LSISerLeaseNo);
            setType(customerRes?.data?.dropdowns?.LSISerUnitTypeDesc);
        } catch (error) {
            console.error('Error fetching data:', error?.customerRes?.data?.message);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        setFormData({
            ...formData,
            property: selectedOption,
        });
        const Invoice = new URLSearchParams();
        Invoice.append('DropdownFor', 'LSISerUnitsByPropId');
        Invoice.append('CascadValue', selectedOption?.value);
        const Invoiceres = await apiService.getApiParamater('GET_INVOICE_CASCAD', `?${Invoice.toString()}`);
        setUnitList(Invoiceres?.data?.items)

        const Customer = new URLSearchParams();
        Customer.append('DropdownFor', 'LSISerTenantsByPropId');
        Customer.append('CascadValue', selectedOption?.value);
        const resCustomer = await apiService.getApiParamater('GET_INVOICE_CASCAD', `?${Customer.toString()}`);
        setLeasingAgent(resCustomer?.data?.items);

        const params = new URLSearchParams();
        params.append('DropdownFor', 'LSISerLeaseNosByPropId');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('GET_INVOICE_CASCAD', `?${params.toString()}`);
        setleaseList(res?.data?.items);

    }
    const handleClearFilters = () => {
        setFormData({
            itemNo: { label: 'Select ItemNo', value: 'All' },
            ItemDescription: { label: 'Select Item', value: 'All' },
            email: "",
            property: [{ label: 'Select Property', value: 'Select Property' }],
            unit: [{ label: 'Select Unit', value: 'Select Unit' }],
            type: [{ label: 'Select Type', value: 'Select Type' }],
            tanent: [{ label: 'Select Tenant', value: 'Select Tenant' }],
            leaseNo: [{ label: 'Select Lease No', value: 'Select Lease No' }],
        });
        setLeaseTerm([]);
        setGroupId(false)
    }
    const handleUnitChange = async (selectedOption) => {
        setFormData({
            ...formData,
            unit: selectedOption,
        });
    }
    const handleLeaseNo = async (selectedOption) => {
        setFormData({
            ...formData,
            leaseNo: selectedOption,
        });
    }
    const handleCustomer = async (selectedOption) => {
        setFormData({
            ...formData,
            tanent: selectedOption,
        });
    }
    const handleSubCategoryChange = async (selectedOption) => {
        setFormData({
            ...formData,
            type: selectedOption,
        });
    }
    const handleSearch = async () => {
        const Invoice = new URLSearchParams();
        Invoice.append('Action', 'GetLSIReceivables');
        Invoice.append('TenantNo', formData?.tanent?.value || 'All');
        Invoice.append('PropertyNo', formData?.property?.value || 'All');
        Invoice.append('UnitType', formData?.type?.label || 'All');
        Invoice.append('UnitNo', formData?.unit?.label || 'All');
        Invoice.append('LeaseNo', formData?.leaseNo?.label || 'All');
        Invoice.append('FromDate', periodFrom);
        Invoice.append('ToDate', periodTo);
        Invoice.append('ShowOther', groupId);

        const Invoiceres = await apiService.getApiParamater('GET_INVOICE_COMMON', `?${Invoice.toString()}`);
        if (Invoiceres?.data?.result?.data?.length === 0) {
            toast.error("No record in selected Property")
        } else {
            setLeaseTerm(Invoiceres?.data?.result?.data)
        }
    }
    const handleActiveSelection = (e) => {
        setGroupId(e);
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const columnDefs = [
        {
            checkboxSelection: true,
            headerCheckboxSelection: true, // Enables "select all" in header
            headerCheckboxSelectionFilteredOnly: true,
            suppressMovable: true,
            width: 80,
            pinned: 'left'
        },
        // { headerName: 'Select', field: 'Selected', headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 80, pinned: 'left' },
        { headerName: 'Lease No', field: 'LeaseNo', filter: true, floatingfilter: true, suppressMovable: true, width: 120, pinned: 'left' },
        { headerName: 'Property', field: 'PropertyName', filter: true, floatingfilter: true, suppressMovable: true, width: 280 },
        { headerName: 'Unit No', field: 'UnitNo', filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Tenant No', field: 'TenantNo', filter: true, floatingfilter: true, suppressMovable: true, width: 170 },
        { headerName: 'Tax', field: 'Tax', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
        { headerName: 'Rent', field: 'Rent', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
        { headerName: 'VAT', field: 'VAT', filter: true, floatingfilter: true, suppressMovable: true, width: 140 },
        { headerName: 'Total', field: 'Total', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
        {
            headerName: "Start", field: "LeaseStart", filter: true, floatingfilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: "End", field: "LeaseEnd", filter: true, floatingfilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },

    ]
    const onRowSelected = (event) => {
        const api = event.api;
        const isSelected = event.node.isSelected();
        const leaseNo = event.data.LeaseNo;

        // Apply same action to all rows with the same LeaseNo
        api.forEachNode((node) => {
            if (node.data.LeaseNo === leaseNo) {
                node.setSelected(isSelected);
            }
        });

        if (isSelected) {
            // ADD all rows with this LeaseNo to selectedRows
            const sameLeaseRows = [];
            api.forEachNode((node) => {
                if (node.isSelected() && node.data.LeaseNo === leaseNo) {
                    sameLeaseRows.push(node.data);
                }
            });

            setSelectedRows((prev) => {
                // Avoid duplicates
                const existingLeaseNos = new Set(prev.map(r => r.PSMId));
                return [...prev, ...sameLeaseRows.filter(r => !existingLeaseNos.has(r.PSMId))];
            });
        } else {
            // REMOVE all rows with this LeaseNo from selectedRows
            setSelectedRows((prev) => prev.filter(r => r.LeaseNo !== leaseNo));
        }
    }
    const handleSave = async () => {
        try {
            setloader(true);
            if (!transectionDate) {
                toast.warning(`Please Select TransectionDate`);
                setloader(false);
                return;
            }

            const currentDatetimeUTC = new Date().toISOString();

            if (selectedRows.length === 0) {
                toast.warning(`Please Select Lease No to Create Invoice`);
                setloader(false);
                return;
            }


            const Invoice = new URLSearchParams();
            Invoice.append('Action', 'chkPostingDateInFinYear');
            Invoice.append('FromDate', transectionDate);

            const Invoiceres = await apiService.getApiParamater('GET_INVOICE_COMMON', `?${Invoice.toString()}`);

            let result = Invoiceres?.data?.result?.data
            if (result?.length === 0) {
                toast.warning("Posting Date should be between Financial Year..!!")
                setloader(false);
                return
            } else if (result?.length > 0) {
                const accountDetailsList = selectedRows.map((item, index) => ({
                    leaseNo: item?.LeaseNo,
                    propertyNo: item?.PropertyNo,
                    propertyName: item?.PropertyName,
                    unitNo: item?.UnitNo,
                    tenantNo: item?.TenantNo,
                    tenantName: item?.TenantName,
                    tax: item?.Tax,
                    rent: item?.Rent,
                    amount: item?.CNAmount,
                    vat: item?.VAT,
                    total: item?.Total,
                    leaseStart: item?.LeaseStart,
                    leaseEnd: item?.LeaseEnd,
                    selected: true,
                    psmId: item?.PSMId,
                    groupId: item?.GroupId,
                    status: item?.Status,
                    taxCode: item?.TaxCode,
                    taxInclusive: item?.TaxInclusive,
                    vatPercent: item?.VATPercent,
                    narration: item?.Narration,
                    vatAcCode: item?.VATAcCode,
                    vatAcName: item?.VATAcName,
                    psdId: item?.PSDId,
                    liRecordId: item?.LIRecordId,
                    tranId: item?.TranId,
                    isInvoiceGenerated: item?.IsInvoiceGenerated,
                    category: item?.Category,
                    invoiceNo: item?.InvoiceNo,
                    invoiceDate: item?.InvoiceDate,
                    dueDate: item?.DueDate,
                    postingDate: item?.PostingDate,
                    isApproved: item?.IsApproved,
                    isOther: false,
                    isSD: true,
                    description: "0",
                    received: 0,
                    refNo: "0",
                    isCreditNoteMade: item?.IsCreditNoteMade,
                    isChecked: true
                }));
                const leaseInvoice = {
                    recordId: 0,
                    leaseNo: "0",
                    propertyNo: "0",
                    propertyName: "0",
                    unitNo: "0",
                    unitRefNo: "0",
                    tenantNo: "0",
                    tenantName: "0",
                    voucherType: "0",
                    psId: 0,
                    paymentType: "0",
                    amount: 0,
                    vatPercent: 0,
                    vat: 0,
                    stPercent: 0,
                    st: 0,
                    total: 0,
                    amountReceived: 0,
                    dueDate: currentDatetimeUTC,
                    postingDate: currentDatetimeUTC,
                    postingId: "0",
                    voucherNo: "0",
                    financialYear: "0",
                    creditAcCode: "0",
                    debitAcCode: "0",
                    tranId: 0,
                    category: "0",
                    taxCode: 0,
                    remarks: "0",
                    isApproved: true,
                    approvedDate: currentDatetimeUTC,
                    approvedBy: "0",
                    exp1: "0",
                    exp2: "0",
                    exp3: "0",
                    exp4: "0",
                    exp5: "0",
                    modifiedBy: "0",
                    modifiedOn: currentDatetimeUTC,
                    createdBy: "0",
                    createdOn: currentDatetimeUTC,
                    leaseFromDate: currentDatetimeUTC,
                    leaseToDate: currentDatetimeUTC,
                    transactionDate: currentDatetimeUTC
                };

                const body = {
                    singleInvoiceMain: {
                        leaseInvoice: leaseInvoice,
                        accountDetailsList: accountDetailsList,
                        creditNote_PostingDate: moment(transectionDate).format("YYYY-MM-DDTHH:mm:ss")
                    },
                };

                const postRes = await apiService.post("POST_SINGLE_INVOICE", body);
                if (postRes?.data?.statusCode === 201) {
                    toast.success(`Invoice Created successfully`);
                    setloader(false);
                    window.location.reload();
                    // navigate("/Property/Management/LeaseAgreement");
                } else {
                    setloader(false);
                }
            }
        } catch (error) {
            setloader(false);

            console.error("Error Save Data", error);
        }
    }
    return (
        <div className='p-3'>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Generate Invoice</div>
            </div>
            <div className='gridBg m-0 row' style={{ borderRadius: "0px 0px 16px 16px" }}>
                <div className='col-9 form-group' style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '10px' }}>
                    <div className='d-flex'>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            className="p-0 w-100"
                            value={formData.property}
                            options={propertylist?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                            onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                        />
                    </div>
                    <div className='d-flex'>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.tanent}
                            options={leasingAgent?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                            onChange={(selectedOption) => handleCustomer(selectedOption)}
                        />
                    </div>
                    <div className='d-flex gap-3'>
                        <label className='form-label'>LeaseDate</label>
                        <DatePicker
                            todayButton="Today"
                            selected={periodFrom}
                            onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className='d-flex'>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            className="p-0 w-100"
                            value={formData.unit}
                            options={unitList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                            onChange={(selectedOption) => handleUnitChange(selectedOption)}
                        />
                    </div>
                    <div className='d-flex'>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData?.leaseNo}
                            onChange={(selectedOption) => handleLeaseNo(selectedOption)}
                            options={leaseList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                        />
                    </div>
                    <div className='d-flex gap-3'>
                        <label className='form-label'>LeaseExpiry</label>
                        <DatePicker
                            todayButton="Today"
                            selected={periodTo}
                            onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className='d-flex'>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData?.type}
                            onChange={(selectedOption) => handleSubCategoryChange(selectedOption)}
                            options={typeList?.map((SubCatOpt) => ({ value: SubCatOpt?.value, label: SubCatOpt?.text }))}
                        />
                    </div>
                    <div className='d-flex gap-3'>
                        <label className='form-label'>Transection Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionDate}
                            onChange={(date) => handleTransDate({ name: 'transectionDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className='d-flex'>
                        <input type="file" className="form-control" />
                    </div>
                    <div className='d-flex'  >
                        <div className='d-flex mt-2 gap-4 '>
                            <input className="form-check-input"
                                type="checkbox"
                                id="groupId" style={{ width: "20px", height: "20px" }}
                                name="groupId"
                                checked={groupId}
                                onChange={(e) => handleActiveSelection(e.target.checked)}
                            />
                            <label className='form-label center mt-2'>Include other Charges</label>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='mainbtnGry flex-end gap-2 mt-2'>
                            <FaSave color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Save Point</div>
                        </div>
                    </div>
                </div>
                <div className='col-3 '>
                    <div onClick={() => handleSearch()} className='mainbtnGry flex-end mt-2 gap-2'>
                        <IoSearch color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Search</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end my-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                    {loading === true ? (
                        <div className="mainbtn flex-end gap-2">
                            <ClipLoader color="#ffffff" className="mt-1" size={25} />
                        </div>
                    ) : (
                        <div className="mainbtn flex-end gap-2" onClick={handleSave}>
                            <FaSave color="#fff" className="center mt-2 mx-2" />
                            <div className="center">Save</div>
                        </div>
                    )}
                </div>
            </div>
            <div className='gridshad mt-1'>
                <div className='table-container' style={{ overflowX: 'auto', height: "490px" }}>
                    <div className="ag-theme-quartz" style={{ height: 650 }}>
                        <AgGridReact
                            rowData={leaseTerm}
                            columnDefs={columnDefs}
                            rowSelection="multiple"
                            onRowSelected={onRowSelected} // ✅ Changed here
                            suppressRowClickSelection={true}
                            // onSelectionChanged={onSelectionChanged}
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                        />
                    </div>
                </div>
                <div className='d-flex justify-content-between boxs'>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Lease Count</div>
                        <div className='field'>{`${leaseTerm?.length || 0}` || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Rent </div>
                        <div className='field'>{totalRent || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Vat</div>
                        <div className='field'>{totalVat || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Amount</div>
                        <div className='field'>{totalAmount || "---"}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SingleInvoice;